<template>
  <div class="billInfo">
    <vxe-grid
      border
      show-overflow
      resizable
      ref="billInfo"
      class="vxe-table-element"
      size="mini"
      align="left"
      :auto-resize="true"
      :data="tableData"
      :columns="columnList"
      :edit-rules="
        canEdit && (paymentMethod == 'FK12' || paymentMethod == 'FK05' || paymentMethod == 'FK07')
          ? rules
          : {}
      "
      :toolbar="
        canEdit && (paymentMethod == 'FK12' || paymentMethod == 'FK05' || paymentMethod == 'FK07')
          ? {}
          : null
      "
      :edit-config="{ trigger: 'click', mode: 'row', activeMethod: activeRowMethod }"
      :valid-config="{ autoPos: true, message: 'inline' }"
      show-footer
      :footer-method="footerMethod"
    >
      <template v-slot:buttons>
        <vxe-button
          @click="insertEvent()"
          type="primary"
          icon="el-icon-plus"
          class="vxe-btn-primary"
          >{{ $t('cooperation.buttons.add') }}</vxe-button
        >
        <vxe-button
          @click="handleDelete()"
          type="primary"
          icon="el-icon-delete"
          class="vxe-btn-delete"
          >{{ $t('cooperation.buttons.delete') }}</vxe-button
        >
      </template>
    </vxe-grid>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  // import SearchTable from '@/components/form-item/search-table';
  // import InputNumber from '@/components/form-item/input-number';
  // import API from '@/api/capitalCenter/moneyDraw';

  export default {
    name: 'billInfo',
    components: {
      // SearchTable,
      // InputNumber,
    },
    props: ['canEdit', 'paymentMethod', 'currencyCode', 'invoiceLineAmount', 'paymentCompanyCode'],
    data() {
      return {
        tableData: [],
        addRowObj: {
          billId: null,
          billDepartmentName: null,
          billDepartmentNo: null,
          billCode: null,
          billAmount: null,
          billCategory: null,
          billCategoryName: null,
          billProperty: null,
        },
      };
    },
    computed: {
      ...mapState({
        dictList: (state) => state.dict.dictList,
      }),
      extraData() {
        let extraData = {
          currency: this.currencyCode,
          billStatus: '01',
          billCompanyCode: this.paymentCompanyCode,
        };
        // 当为票据转让时,应收票据票据池可用状态的票据
        if (this.paymentMethod == 'FK12') {
          extraData = {
            ...extraData,
            billType: '1',
          };
        }
        // 当为银行承兑汇票时,该字段必输,且能选到的票据号为(银行承兑类型的)应付票据票据池
        if (this.paymentMethod == 'FK05') {
          extraData = {
            ...extraData,
            billProperty: 'B',
            billType: '2',
          };
        }
        // 当为商业承兑汇票时,且能选到的票据号为(商业承兑)可用状态的应付票据
        if (this.paymentMethod == 'FK07') {
          extraData = {
            ...extraData,
            billProperty: 'D',
            billType: '2',
          };
        }
        return extraData;
      },
      //基础数据表单配置
      columnList() {
        return [
          { type: 'checkbox', width: 50 },
          {
            // 行号
            type: 'seq',
            width: 50,
            title: this.$t('paymentListAdd.invoiceLine.billInfo.lineNumber'),
          },
          {
            // 部门
            field: 'billDepartmentName',
            title: this.$t('paymentListAdd.invoiceLine.billInfo.departmentCode'),
          },
          {
            // 票据号
            field: 'billCode',
            title: this.$t('paymentListAdd.invoiceLine.billInfo.billCode'),
            ...(this.paymentMethod == 'FK12' ||
            this.paymentMethod == 'FK05' ||
            this.paymentMethod == 'FK07'
              ? {
                  editRender: { name: 'ElInput', props: { clearable: true } },
                  slots: {
                    default: ({ row }) => {
                      return [<span>{row.billCode}</span>];
                    },
                    edit: ({ row }) => {
                      return [
                        <search-table
                          searchType="bill"
                          isMultiple={true}
                          currentValue={row['billCode']}
                          checkRowKeys={[row['billCode']]}
                          extraData={this.extraData}
                          onInput={(val) => this.chooseTable(val, row)}
                        ></search-table>,
                      ];
                    },
                  },
                }
              : {}),
          },
          {
            // 票据金额
            field: 'billAmount',
            title: this.$t('paymentListAdd.invoiceLine.billInfo.billAmount'),
          },
          {
            // 票据类型改为票据性质
            field: 'billProperty',
            // title: this.$t("paymentListAdd.invoiceLine.billInfo.billType"),
            title: '票据性质',
            formatter: this.formatterBillProperty,
          },
        ];
      },
      rules() {
        return {
          billCode: [
            {
              required: true,
              message: this.$t('paymentListAdd.invoiceLine.billInfo.billCodePlaceholder'),
            },
          ],
        };
      },
    },
    mounted() {},
    methods: {
      formatterBillProperty({ cellValue }) {
        return this.$baseRequest.getDictValueByType('bill_property', cellValue);
      },
      chooseTable(val, row) {
        if (val && val.length > 0 && val[0].billCode) {
          const billIds = this.$refs.billInfo.getTableData().fullData.map((item) => item.billId);
          if (billIds.includes(val[0].id)) {
            this.$message({
              showClose: true,
              message: '该票据已被当前付款单引用，请重新选择！',
              type: 'error',
            });
            this.clearRow(row);
            return;
          }
          row.billId = val[0].id;
          row.billDepartmentName = val[0].billTakeDepartmentName;
          row.billDepartmentNo = val[0].billTakeDepartmentNo;
          row.billCode = val[0].billCode;
          row.billAmount = val[0].billAmount;
          row.billCategory = val[0].billCategory;
          row.billCategoryName = this.dictList
            .find((it) => it.dictType == 'bill_category')
            .dictList.find((it) => it.value == val[0].billCategory).label;
          row.billProperty = val[0].billProperty;
        } else {
          this.clearRow(row);
        }
      },
      clearRow(row) {
        row.billId = null;
        row.billDepartmentName = null;
        row.billDepartmentNo = null;
        row.billCode = null;
        row.billAmount = null;
        row.billCategory = null;
        row.billCategoryName = null;
        row.billProperty = null;
      },
      // 载具表格新增一行
      insertEvent(row) {
        this.$refs.billInfo.validate().then(() => {
          let record = { ...this.addRowObj };
          this.$refs.billInfo.insertAt(record, row).then(({ row }) => {
            this.$refs.billInfo.setActiveRow(row);
          });
        });
      },
      handleDelete() {
        const selectedList = this.$refs.billInfo.getSelectRecords(); // 或许选中数据
        if (selectedList.length < 1) {
          return this.tips('noData', 'error');
        }
        this.$confirmAction()
          .then(() => {
            this.$refs.billInfo.removeSelecteds();
            this.tips('deleteSuccess', 'success');
          })
          .catch(() => {
            this.tips('cancelled', 'error');
          });
      },
      // 合计
      footerMethod({ columns, data }) {
        let returnAmountProps = ['billAmount'];
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex == 1) {
              return this.$t('paymentListAdd.invoiceLine.billInfo.total');
            }
            if (returnAmountProps.includes(column.property)) {
              let subtrahend = 0;
              for (let i = 0; i < data.length; i++) {
                subtrahend = this.$cal.calCommon(data[i][column.property], subtrahend, '+');
              }
              return subtrahend;
            }
            return null;
          }),
        ];
      },
      activeRowMethod() {
        return this.canEdit;
      },
      // 返回数据
      exportChildData() {
        const tableData = this.$refs.billInfo.getTableData().fullData;
        // 点击提交，走校验
        if (tableData.length == 0) {
          if (this.paymentMethod == 'FK05') {
            this.tips('noBill', 'error');
            return false;
          }
          return [];
        } else {
          return new Promise((resolve) => {
            this.$refs.billInfo.validate().then(() => {
              resolve(tableData);
            });
          });
        }
      },
      // 提示
      tips(info, type) {
        this.$message({
          showClose: true,
          message: this.$t(`paymentListAdd.message.${info}`),
          type: type,
        });
      },
    },
    watch: {
      paymentMethod(newV) {
        if (newV != 'FK12' && newV != 'FK05' && newV != 'FK07') {
          this.tableData = [];
        }
      },
    },
  };
</script>
